<template>
  <div class="contact">
    <section class="page-hero">
      <div class="container">
        <span class="eyebrow eyebrow-light">{{ $t('contact.hero.eyebrow') }}</span>
        <h1>{{ $t('contact.hero.title') }}</h1>
        <p>{{ $t('contact.hero.subtitle') }}</p>
      </div>
    </section>

    <section class="section">
      <div class="container contact-layout">
        <div class="card info-card">
          <h2>{{ $t('contact.info.title') }}</h2>
          <ul class="info-list">
            <li><IconBadge icon="pin" tone="green" size="sm" /> {{ $t('footer.address') }}</li>
            <li><IconBadge icon="phone" tone="green" size="sm" /> <a href="tel:+919826033529">+91-9826033529</a></li>
            <li><IconBadge icon="mail" tone="green" size="sm" /> <a href="mailto:info@hindkrantisenafoundation.org">info@hindkrantisenafoundation.org</a></li>
          </ul>
          <h3>{{ $t('contact.volunteerInterests.title') }}</h3>
          <ul class="tag-list">
            <li>{{ $t('contact.volunteerInterests.women') }}</li>
            <li>{{ $t('contact.volunteerInterests.animals') }}</li>
            <li>{{ $t('contact.volunteerInterests.trees') }}</li>
            <li>{{ $t('contact.volunteerInterests.clean') }}</li>
            <li>{{ $t('contact.volunteerInterests.advocacy') }}</li>
          </ul>
        </div>

        <div class="card form-card">
          <h2>{{ $t('contact.form.title') }}</h2>
          <form @submit.prevent="sent = true" v-if="!sent">
            <input type="text" :placeholder="$t('contact.form.namePh')" required />
            <input type="email" :placeholder="$t('contact.form.emailPh')" required />
            <select v-model="interest">
              <option value="" disabled>{{ $t('contact.form.interestPh') }}</option>
              <option value="women">{{ $t('contact.volunteerInterests.women') }}</option>
              <option value="animals">{{ $t('contact.volunteerInterests.animals') }}</option>
              <option value="trees">{{ $t('contact.volunteerInterests.trees') }}</option>
              <option value="clean">{{ $t('contact.volunteerInterests.clean') }}</option>
              <option value="other">{{ $t('contact.form.other') }}</option>
            </select>
            <textarea rows="4" :placeholder="$t('contact.form.messagePh')"></textarea>
            <button type="submit" class="btn btn-primary">{{ $t('contact.form.submit') }}</button>
          </form>
          <div class="thanks" v-else>
            <IconBadge icon="check" tone="green" size="lg" />
            <h3>{{ $t('contact.thanks.title') }}</h3>
            <p>{{ $t('contact.thanks.text') }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import IconBadge from '@/components/IconBadge.vue';

export default {
  name: 'ContactUs',
  components: { IconBadge },
  data() {
    return { interest: '', sent: false };
  },
};
</script>

<style scoped>
.page-hero { background: linear-gradient(135deg, var(--charcoal-dark), var(--charcoal)); color: #fff; padding: 76px 0; text-align: center; }
.eyebrow-light { color: #8FDDD8; text-transform: uppercase; letter-spacing: 1.5px; font-weight: 700; font-size: 0.8rem; }
.page-hero h1 { font-size: clamp(1.7rem, 3.4vw, 2.3rem); margin: 12px 0 10px; }
.page-hero p { color: rgba(255,255,255,0.88); margin: 0 auto; max-width: 520px; }

.contact-layout { display: grid; grid-template-columns: 1fr 1.2fr; gap: 26px; align-items: start; }
@media (max-width: 860px) { .contact-layout { grid-template-columns: 1fr; } }

.info-card h2, .form-card h2 { color: var(--charcoal); margin-bottom: 18px; font-size: 1.2rem; }
.info-list { list-style: none; padding: 0; margin: 0 0 26px; display: flex; flex-direction: column; gap: 16px; font-size: 0.95rem; }
.info-list li { display: flex; align-items: center; gap: 12px; }
.info-list a { color: var(--ink); text-decoration: none; }
.info-list a:hover { color: var(--brand-teal-dark); }
.info-card h3 { font-size: 1rem; color: var(--charcoal); margin-bottom: 10px; }
.tag-list { list-style: none; padding: 0; margin: 0; display: flex; flex-wrap: wrap; gap: 8px; }
.tag-list li { background: var(--brand-teal-tint); color: var(--brand-teal-dark); border-radius: 999px; padding: 6px 14px; font-size: 0.82rem; font-weight: 600; }

form { display: flex; flex-direction: column; gap: 14px; }
form input, form select, form textarea {
  padding: 12px 14px; border: 1px solid var(--border); border-radius: 10px; font-size: 0.95rem; font-family: inherit;
}
form button { align-self: flex-start; }

.thanks { text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 20px 0; }
.thanks h3 { color: var(--charcoal); }
.thanks p { color: var(--muted); margin: 0; }
</style>
